<template>
	<div class="teach-source">
		<div class="center">
			<p class="description">下方是可以輔助您將 DFC 四步驟融入課堂中的各式教學資源，可以搭配您的教學自由運用，若有任何使用上的回饋，歡迎跟我們及時反應喔！</p>
		</div>
		<el-table :data="dataList.list" fit stripe style="width: 100%; margin-top:40px;">
			<el-table-column prop="title" label="名稱" />
			<el-table-column prop="step" label="階段" />
			<el-table-column prop="brief" label="簡介">
				<pre slot-scope="{row}">{{row.brief}}</pre>
			</el-table-column>
			<el-table-column prop="goal" label="目標">
				<pre slot-scope="{row}">{{row.goal}}</pre>
			</el-table-column>
			<el-table-column label="" align="center" width="50">
				<template slot-scope="{row}">
					<a :href="row.link" target="_blank">預覽</a>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="frequency" label="下載次數" /> -->
		</el-table>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	data() {
		return {};
	},
	computed: {
		...mapState('resource', ['dataList']),
	},
	methods: {},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.teach-source {
	.description {
		max-width:435px;
		line-height: 1.5em;
		text-align: center;
	}
	.pagination {
		margin-top: 50px;

		.el-pagination {
			display: flex;
			justify-content: center;
		}
	}
}
</style>